export default function hasInvalidCharacters(value: string) {
  // Note: this is roughly equivalent (without utf-8 check) to server's strutil.HasInvalidCharacters
  // If you're changing this, it might be useful to check if server needs to change as well.
  return value.includes('�');
}
